import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app';
import { CONNECT_ROLE } from 'utils/constants';

interface ModalState {
  visible: boolean;
  data: {
    isMultiMode: boolean;
    orderIDs: string[] | undefined;
    orderID: string | undefined;
    role: number | undefined;
  };
}

const initialState: ModalState = {
  visible: false,
  data: {
    isMultiMode: false,
    orderIDs: undefined,
    orderID: undefined,
    role: CONNECT_ROLE.SUPPLIER,
  },
};

const exportBillModalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openExportBillModal(
      state,
      action: PayloadAction<{
        isMultiMode?: boolean;
        orderIDs?: string[] | undefined;
        orderID?: string | undefined;
        role?: number | undefined;
      }>
    ) {
      state.visible = true;
      state.data.isMultiMode = action.payload?.isMultiMode ?? false;
      state.data.orderID = action.payload?.orderID;
      state.data.orderIDs = action.payload?.orderIDs;
      state.data.role = action.payload?.role ?? CONNECT_ROLE.SUPPLIER;
    },
    cancelExportBillModal(state) {
      state.visible = false;
      state.data = {
        isMultiMode: false,
        orderIDs: undefined,
        orderID: undefined,
        role: undefined,
      };
    },
  },
  extraReducers: {},
});

const { actions, reducer: exportBillModalReducer } = exportBillModalSlice;

export const { openExportBillModal, cancelExportBillModal } = actions;

export default exportBillModalReducer;

export const selectExportBillModal = (state: RootState): ModalState =>
  state.exportBillModal as ModalState;
